@let address = config().company.address;

<footer class="footer">
  <div class="footer-company">
    @if (config().header.logo; as logo) {
      <div class="footer-logo">
        <ui-image [data]="logo" objectFit="contain"></ui-image>
      </div>
    }

    <div class="footer-details">
      <address class="footer-address">
        @if (address.name; as name) {
          <strong class="footer-title">{{ name }}</strong>
        }
        <span>{{ address.street }}</span>
        <span>{{ address.postalCode }} {{ address.locality }}</span>

        @if (address.countryName; as countryName) {
          <span>{{ countryName }}</span>
        }
      </address>

      <address class="footer-contact">
        @if (address.telephone; as telephone) {
          <a [href]="'tel:' + telephone">{{ telephone }}</a>
        }

        @if (address.email; as email) {
          <a class="footer-email" [href]="'mailto:' + email">{{ email }}</a>
        }
      </address>
    </div>
  </div>

  <div class="footer-bottom">
    <p class="footer-copyright">{{ copyrightText() }}</p>

    @if (legalLinks().length) {
      <nav class="footer-legal">
        <ul>
          @for (item of legalLinks(); track item.id) {
            <li>
              <a [link]="item" uiNavLink>{{ item.label }}</a>
            </li>
          }
        </ul>
      </nav>
    }
  </div>
</footer>
